export const BUTTON_DOWNLOAD_REQUEST = "BUTTON_DOWNLOAD_REQUEST";
export const BUTTON_DOWNLOAD_SUCCESS = "BUTTON_DOWNLOAD_SUCCESS";
export const BUTTON_DOWNLOAD_FAIL = "BUTTON_DOWNLOAD_FAIL";
export const BUTTON_DOWNLOAD_RESET = "BUTTON_DOWNLOAD_RESET";
